import { defineStore } from 'pinia';

type SellerDialogSettings = {
  forceSellerSelection?: boolean,
  sellerError?: boolean,
  sellerMissing?: boolean,
  clubInactive?: boolean,
  clubPastDeadline?: boolean,
  clubError?: boolean,
}

export const useUiStore = defineStore('uiStore', {
  state: () => ({
    isMobile: true,
    isTabletPortrait: false,
    tempErrorMsg: null as string | null,
    showSellerDialog: false,
    sellerDialogSettings: {
      forceSellerSelection: false,
      sellerError: false,
      sellerMissing: false,
      clubInactive: false,
      clubPastDeadline: false,
      clubError: false,
    } as SellerDialogSettings,
  }),
  actions: {
    setError(payload: string, fadeTime = 0) {
      console.warn('setError');
      console.log(payload);
      this.tempErrorMsg = payload;
      if (fadeTime > 0) {
        setTimeout(() => {
          this.tempErrorMsg = null;
        }, fadeTime);
      }
    },
  },
});
